import { finish, error } from '../../../modules/customers/actions/get-freebet-history';

import api from '../../../api';

export function request( dispatch, { customerId, name, conditions } ) {
    api.post( `/user/freebet/${customerId}/history`, conditions, { cache: true } ).then(
        ( { history } ) => dispatch( finish( customerId, name, history ) ),
        ( { errors } ) => dispatch( error( customerId, name, errors ) )
    );
}
